import { Controller } from "@hotwired/stimulus"

// Carte TVA de Paramètres > Identité. Elle suit la situation cochée PLUS HAUT
// dans le même formulaire, sans attendre l'enregistrement : le 24/09/2026,
// cocher « J'ai une société » laissait « Rien à régler » affiché.
// La règle recopie Workspace#tva_question_posee? :
//   auto-entrepreneur          → pas de question (contribution unique)
//   société, ou matricule rempli → la question
//   sinon                      → rien à régler, BEB facture
// Le champ de taux ne s'affiche qu'après « Oui » : montrer un taux à
// quelqu'un qui ne collecte pas de TVA, c'est l'inviter à se tromper.
export default class extends Controller {
  static targets = ["panneauAe", "panneauSans", "panneauQuestion", "blocTaux"]

  connect() {
    this.formulaire = this.element.closest("form")
    this.suivre = () => this.situation()
    this.formulaire?.addEventListener("change", this.suivre)
    this.formulaire?.addEventListener("input", this.suivre)
    this.situation()
  }

  disconnect() {
    this.formulaire?.removeEventListener("change", this.suivre)
    this.formulaire?.removeEventListener("input", this.suivre)
  }

  situation() {
    if (!this.formulaire) return
    const kind = this.formulaire.querySelector('input[name$="[situation]"]:checked')?.value || ""
    const matricule = this.formulaire.querySelector('input[name$="[provider_tax_id]"]')?.value.trim() || ""

    let etat = "sans"
    if (kind === "auto_entrepreneur") etat = "ae"
    else if (kind === "company" || matricule !== "") etat = "question"

    this.panneauAeTarget.hidden = etat !== "ae"
    this.panneauSansTarget.hidden = etat !== "sans"
    this.panneauQuestionTarget.hidden = etat !== "question"
    this.actualiser()
  }

  actualiser() {
    const coche = this.element.querySelector('input[type="radio"][name$="[tva_assujetti]"]:checked')
    this.blocTauxTarget.hidden = !(coche && coche.value === "true")
  }
}
